"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddOfferToBasketUIKey = void 0;
var getAddOfferToBasketUIKey = exports.getAddOfferToBasketUIKey = function getAddOfferToBasketUIKey(basketID) {
  return "ADD_OFFER_TO_BASKETS_UI_".concat(basketID);
};